/* eslint-disable */
export function kfp(): string {
    return 'kfp';
}
